import { render, staticRenderFns } from "./QuickNotice.vue?vue&type=template&id=9df01974&scoped=true&name=quickNotice&"
import script from "./QuickNotice.vue?vue&type=script&lang=js&"
export * from "./QuickNotice.vue?vue&type=script&lang=js&"
import style0 from "./QuickNotice.vue?vue&type=style&index=0&id=9df01974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df01974",
  null
  
)

export default component.exports